// extracted by mini-css-extract-plugin
module.exports = {"releases":"Releases_releases__ZMmx2","releases_wrapper":"Releases_releases_wrapper__JmUrU"};